import React, { useState } from 'react';
import { Layout, Menu, Button, Drawer, Grid, Typography } from 'antd';
import {
  MenuOutlined,
  BookOutlined,
  GlobalOutlined,
  LogoutOutlined,
  DeploymentUnitOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const { Header, Sider, Content } = Layout;

export function DashboardLayout() {
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const onLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  const selectedKey = (() => {
    const p = location.pathname;
    if (p.startsWith('/dashboard/languages')) return 'languages';
    if (p.startsWith('/dashboard/subantas')) return 'subantas';
    if (p.startsWith('/dashboard/tingantas')) return 'tingantas';
    return 'home';
  })();

  const menuItems = [
    {
      key: 'home',
      icon: <BookOutlined />,
      label: 'Dictionary',
      onClick: () => {
        navigate('/dashboard');
        setMobileMenuOpen(false);
      },
    },
    {
      key: 'languages',
      icon: <GlobalOutlined />,
      label: 'Languages',
      onClick: () => {
        navigate('/dashboard/languages');
        setMobileMenuOpen(false);
      },
    },
    {
      key: 'subantas',
      icon: <DeploymentUnitOutlined />,
      label: 'Subanta',
      onClick: () => {
        navigate('/dashboard/subantas');
        setMobileMenuOpen(false);
      },
    },
    {
      key: 'tingantas',
      icon: <ThunderboltOutlined />,
      label: 'Tinganta',
      onClick: () => {
        navigate('/dashboard/tingantas');
        setMobileMenuOpen(false);
      },
    },
  ];

  const menu = (
    <Menu
      theme="dark"
      mode="inline"
      selectedKeys={[selectedKey]}
      items={menuItems.map(({ key, icon, label, onClick }) => ({
        key,
        icon,
        label,
        onClick,
      }))}
    />
  );

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {!isMobile ? (
        <Sider width={240} theme="dark">
          <div style={{ padding: 16, color: 'rgba(255,255,255,0.85)', fontWeight: 600 }}>
            Vag Dictionary
          </div>
          {menu}
        </Sider>
      ) : null}

      <Layout>
        <Header
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            paddingInline: 16,
            background: '#fff',
            borderBottom: '1px solid #f0f0f0',
          }}
        >
          {isMobile ? (
            <Button
              type="text"
              icon={<MenuOutlined />}
              aria-label="Open menu"
              onClick={() => setMobileMenuOpen(true)}
            />
          ) : null}
          <Typography.Title level={4} style={{ margin: 0, flex: 1 }}>
            Dashboard
          </Typography.Title>
          <Typography.Text type="secondary" ellipsis style={{ maxWidth: 120 }}>
            {user?.username}
          </Typography.Text>
          <Button icon={<LogoutOutlined />} onClick={onLogout}>
            Log out
          </Button>
        </Header>
        <Content style={{ padding: 16, background: '#f5f5f5' }}>
          <Outlet />
        </Content>
      </Layout>

      <Drawer
        title="Menu"
        placement="left"
        onClose={() => setMobileMenuOpen(false)}
        open={isMobile && mobileMenuOpen}
        styles={{ body: { padding: 0 } }}
      >
        {menu}
      </Drawer>
    </Layout>
  );
}
